import {api} from '@/api/factory';

class Movie {
    constructor() {}

    remove(movie_id:number | string) {
        return api.delete(`/v1/content-manager/movies/${movie_id}`)
    }

    get(movie_id:number | string) {
        return api.get(`/v1/content-manager/movies/${movie_id}`)
    }

    create(movie) {
        return api({
            url: `/v1/content-manager/movies/`,
            method: 'POST',
            data: movie
        })
    }

    edit(movie, movie_id) {
        return api({
            url: `/v1/content-manager/movies/${movie_id}`,
            method: 'PUT',
            data: movie
        })
    }

    addVoiceover(movie_id, data) {
        return api({
            url: `/v1/content-manager/movies/${movie_id}/voiceovers`,
            method: 'POST',
            data: data
        })
    }

    removeVoiceoverFromFilm(movie_id, voiceover_id, video_id) {
        return api({
            url: `v1/content-manager/movies/${movie_id}/voiceovers/${voiceover_id}/${video_id}`,
            method: 'DELETE'
        })
    }

    editeVoiceoverFromFilm(movie_id, voiceover_id, video_id, data) {
        return api({
            url: `v1/content-manager/movies/${movie_id}/voiceovers/${voiceover_id}/${video_id}`,
            method: 'PUT',
            data: data
        })
    }

    updateVoiceoversOrder(movie_id: number | string, order: Array<{ video_id: number; sort_order: number }>) {
        return api({
            url: `/v1/content-manager/movies/${movie_id}/voiceovers/order`,
            method: 'PUT',
            data: { voiceovers: order }
        })
    }

    resetVoiceoversOrder(movie_id: number | string) {
        return api({
            url: `/v1/content-manager/movies/${movie_id}/voiceovers/order`,
            method: 'DELETE'
        })
    }
}

export default Movie